import { Component, Input, OnInit } from '@angular/core';
import { ReadConfigService } from '../shared/services/common/read-config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  @Input() selectedOrg: any;
  helpDeskPhone: any;

  constructor(
    private readConfigService: ReadConfigService
  ) { }

  ngOnInit() {
    const config = this.readConfigService.getHelpText();
    this.helpDeskPhone = config.HelpDeskPhone;
  }
}
